<div class="timeline" *ngIf="newsArray">
    <tsv-news class="news" *ngFor="let news of newsArray" [news]="news"></tsv-news>
    <button class="more-btn" mat-flat-button (click)="loadNews()" [disabled]="currentLimit > newsArray.length || pageLimit > newsArray.length">
        Mehr Anzeigen
    </button>
</div>